// Color Swatches Script - حط الكود ده في assets/swatch-colors.js

// تعريف الألوان
const colorMap = {
  // English colors
  'black': '#000000',
  'white': '#ffffff',
  'red': '#ff0000',
  'blue': '#0000ff',
  'green': '#00ff00',
  'yellow': '#ffff00',
  'pink': '#ffc0cb',
  'purple': '#800080',
  'orange': '#ffa500',
  'brown': '#a52a2a',
  'gray': '#808080',
  'grey': '#808080',
  'navy': '#000080',
  'beige': '#f5f5dc',
  'gold': '#ffd700',
  'silver': '#c0c0c0',
  
  // Arabic colors - ألوان بالعربي
  'أسود': '#000000',
  'أبيض': '#ffffff',
  'أحمر': '#ff0000',
  'أزرق': '#0000ff',
  'أخضر': '#00ff00',
  'أصفر': '#ffff00',
  'وردي': '#ffc0cb',
  'بنفسجي': '#800080',
  'برتقالي': '#ffa500',
  'بني': '#a52a2a',
  'رمادي': '#808080',
  'كحلي': '#000080',
  'بيج': '#f5f5dc',
  'ذهبي': '#ffd700',
  'فضي': '#c0c0c0',
  
  // Additional colors
  'maroon': '#800000',
  'olive': '#808000',
  'lime': '#00ff00',
  'aqua': '#00ffff',
  'teal': '#008080',
  'fuchsia': '#ff00ff',
  'coral': '#ff7f50',
  'mint': '#98ff98',
  'lavender': '#e6e6fa',
  'cream': '#fffdd0',
  'khaki': '#f0e68c',
  'tan': '#d2b48c',
  'burgundy': '#800020',
  'turquoise': '#40e0d0',
  'salmon': '#fa8072',
  'peach': '#ffe5b4'
};

// وظيفة لتطبيق الألوان على العناصر
function applySwatchColors() {
  // البحث عن كل عناصر الـ swatches
  const swatches = document.querySelectorAll('.swatch, .color-swatch, [data-swatch]');
  
  swatches.forEach(swatch => {
    // جلب اسم اللون من النص أو من data attribute
    let colorName = swatch.textContent.trim().toLowerCase();
    
    if (swatch.dataset.swatch) {
      colorName = swatch.dataset.swatch.toLowerCase();
    }
    
    // إذا اللون موجود في القائمة، طبّقه
    if (colorMap[colorName]) {
      swatch.style.backgroundColor = colorMap[colorName];
      
      // إضافة border للون الأبيض عشان يبان
      if (colorName === 'white' || colorName === 'أبيض') {
        swatch.style.border = '2px solid #ddd';
      }
    } else {
      // إذا اللون مش موجود، حاول تجيبه من CSS variables
      const computedStyle = getComputedStyle(swatch);
      if (!computedStyle.backgroundColor || computedStyle.backgroundColor === 'rgba(0, 0, 0, 0)') {
        // إذا مافيش لون، حاول تستخرج اللون من اسم الـ class
        const colorFromClass = extractColorFromClass(swatch);
        if (colorFromClass) {
          swatch.style.backgroundColor = colorFromClass;
        }
      }
    }
  });
}

// استخراج اللون من اسم الـ class
function extractColorFromClass(element) {
  const classes = element.className.split(' ');
  for (let cls of classes) {
    const colorName = cls.replace('swatch-', '').toLowerCase();
    if (colorMap[colorName]) {
      return colorMap[colorName];
    }
  }
  return null;
}

// تفعيل الألوان عند تحميل الصفحة
document.addEventListener('DOMContentLoaded', applySwatchColors);

// تفعيل الألوان عند تغيير الـ variant
document.addEventListener('variant:change', applySwatchColors);

// مراقبة التغييرات في DOM للـ AJAX loading
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      applySwatchColors();
    }
  });
});

// بدء المراقبة
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Export للاستخدام في أماكن تانية
window.applySwatchColors = applySwatchColors;
window.colorMap = colorMap;